// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"896c26f3","64":"46a8b52b","123":"5819a098","147":"0711a264","155":"f0d689c9","165":"7d446e78","178":"0a8386b7","360":"fa99d2ab","448":"4b8859a8","595":"3fc3ad4b","638":"c5024ccb","787":"c39ce9fc","796":"0c7fe0fe","815":"f5865cdc","855":"673a4b6b"}[chunkId] + ".chunk.js";
};